import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

const ChildManagerService = {
  

  acceptInvite: async (payload) => {
    try {
      const response = await axiosInstance.post(API.userInvite.acceptInvite, payload);
      return response.data;
    } catch (error) {
      console.error("Error accepting Invite ", error);
      throw error.response?.data || "Failed to accept Invite";
    }
  },

};

export default ChildManagerService;
